<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates41">
<p class="centerImage"><img alt="images" id="plate41" src="images/plate41.jpg"/></p>
<p class="caption">Our mess bar at Darwin, with our victory score-board on the wall – the wing-tip from a Japanese Zero. Harold Leonard seated.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates41.vue?4b7d8be0